export default __webpack_public_path__ + "static/media/CM.d41056f3.svg";